import angular from 'angular';
import uiRouter from 'angular-ui-router';
import trainingCenterComponent from './trainingCenter.component';

let trainingCenterModule = angular.module('trainingCenter', [
  uiRouter
]).config(($stateProvider) => {
	'ngInject';

	$stateProvider.state('trainingCenter', {
		url: '/trainingCenter',
		component: 'trainingCenter',
		data : { pageTitle: 'TRAINING_CENTER' },
		resolve: {
			hasPermission: ($q, $rootScope, Permissions) => {
				'ngInject';
				let deferred = $q.defer();
				if($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINING_ENTRIES)){
					deferred.resolve();
				}else{
					deferred.reject("Access Denied!!");
				}
				return deferred.promise;
			}
		}
	});

})
.component('trainingCenter', trainingCenterComponent)
.name;

export default trainingCenterModule;



// WEBPACK FOOTER //
// ./client/app/components/trainingCenter/trainingCenter.js